import React, { useState } from 'react'
import { Blacked, ModalContent, ModalHeader, ModalTitle, ModalWrapper } from '../styles';
import { Icon } from 'CRM/organism/Main/styles';
import { FaChevronLeft } from 'react-icons/fa6';
import { Select, message } from 'antd'
import API from 'utils/api';
import { useToken } from 'app/hooks';
import {useIsMobile} from "../IsMobile";

export const TotalAccessPathChange = ({ selectTable, setSelectTable, setIsTotalAccessPath, mutate, pathList }) => {
  const IsMobile = useIsMobile();
  const { data: token } = useToken();
  const [accessPathId, setAccessPathId] = useState('');

  const clickSubmit = () => {
    if(accessPathId === '') {
      message.error('출처를 선택하지 않았습니다.')
      return
    }

    const shouldEdit = window.confirm(`선택한 ${selectTable?.length}명의 출처를 "${pathList?.find(it => it.id == accessPathId)?.name}"(으)로 변경하시겠습니까?`);
    if(shouldEdit) {
      API.put('/users/accesspath', token + '', {
        datas: {
          ids: selectTable,
          accessPathId: accessPathId
        }
      })
      .then((res: any) => {
        if (res.result.success) {
          message.success('변경되었습니다');
          mutate();
          setIsTotalAccessPath(false);
          setSelectTable([]);
        } else {
          message.error(res.result.message || '변경에 실패했습니다')
        }
      })
      .catch((err: any) => {})
    }
  }

  return (
    <>
      <Blacked onClick={() => setIsTotalAccessPath(false)} />

      <ModalWrapper IsMobile={IsMobile} style={IsMobile ? {} : {width: '400px'}}>
        <ModalHeader>
          <Icon onClick={() => setIsTotalAccessPath(false)}><FaChevronLeft /></Icon>
          <ModalTitle>일괄출처변경</ModalTitle>
          <div onClick={clickSubmit} style={{cursor: 'pointer', fontWeight: 'bold', color: '#437EFF'}}>저장</div>
        </ModalHeader>
        <ModalContent style={{padding: 20}}>
          <p style={{marginBottom: 12}}>선택한 {selectTable?.length}명의 출처를 일괄 변경합니다.</p>
          <Select
            value={accessPathId}
            onChange={(e) => setAccessPathId(e)}
            style={{fontFamily: 'Pretendard', width: '100%'}}
            placeholder="출처 선택"
          >
            {pathList?.map(it => (
              <option key={it.id} value={it.id} style={{fontFamily: 'Pretendard'}}>{it.name}</option>
            ))}
          </Select>
        </ModalContent>
      </ModalWrapper>
    </>
  )
}

export default React.memo(TotalAccessPathChange);
